import { Language } from "@outschool/business-rules";
import { useTranslation } from "@outschool/localization";

export default function useLanguageString() {
  const { t } = useTranslation(
    "ui-components-website\\hooks\\useLanguageString",
  );

  const translatedLanguages: { [K in Language.LanguageCode]: string } = {
    en: t("English"),
    asl: t("American Sign Language"),
    ar: t("Arabic"),
    bn: t("Bengali"),
    yue: t("Cantonese"),
    fr: t("French"),
    de: t("German"),
    gu: t("Gujarati"),
    hi: t("Hindi"),
    ig: t("Igbo"),
    id: t("Indonesian"),
    it: t("Italian"),
    jam: t("Jamaican Patois"),
    ja: t("Japanese"),
    ko: t("Korean"),
    cmn: t("Mandarin Chinese"),
    pt: t("Portuguese"),
    ru: t("Russian"),
    es: t("Spanish"),
    sw: t("Swahili"),
    ur: t("Urdu"),
    vi: t("Vietnamese"),
    yo: t("Yoruba"),
  };

  const translatedLanguageFilters = Language.LANGUAGE_FILTER_CODES.map(
    code => ({
      label: t("Taught in {{language}}", {
        language: codeToTranslatedText(code),
      }),
      value: code,
    }),
  );

  function codeToTranslatedText(code: Language.LanguageCode) {
    return translatedLanguages[code];
  }

  return {
    translatedLanguageFilters,
    codeToTranslatedText,
  };
}
